import React, { useState, useEffect, useContext } from 'react'
import moment from 'moment';
import { Redirect } from 'react-router';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import AddProjectModal from '../../../components/Modals/AddProjectModal';
import { deleteProjectByUUID, getAuthRolePermissions, getCompanyAgency, getProjectIntegrations, getProjects } from "../../../services/private/company.service"
import { getAllVisibleBanners, getCities, getDeadReasons } from '../../../services/public/public.service';
import PaginationFooter from '../User&Teams/PaginationFooter';
import { createDatewithTime } from '../../../helpers/date';
import PopUpModal from '../../../components/Modals/PopUpModal';
import SearchIcon from '../../../assets/icons/search.svg';
import { ReactComponent as SearchClosIoicn } from '../../../assets/icons/searchClose.svg';
import { ReactComponent as PluswhiteIcon } from '../../../assets/icons/Pluswhite.svg';
import { ReactComponent as ViewlistIcon } from '../../../assets/icons/Viewlist.svg';
import { ReactComponent as ViewgridIcon } from '../../../assets/icons/Viewgrid.svg';
import { ReactComponent as FilterIcon } from '../../../assets/icons/filter.svg';
import { ReactComponent as LaunchIcon } from '../../../assets/icons/Launch.svg';
import { ReactComponent as ThreedotsIcon } from '../../../assets/icons/whitetreedots.svg';
import { ReactComponent as Searchicon } from '../../../assets/icons/searchicon.svg';
import { ReactComponent as HomeWhiteIcon } from '../../../assets/icons/homeWhite.svg';
import { ReactComponent as Vthreedots } from '../../../assets/icons/threedots.svg';
import offerRupee from '../../../assets/icons/offer_rupee.jpg';
import { ReactComponent as PercentIcon } from '../../../assets/icons/booking_percent.svg'

import { useCallback } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import style from './style.module.css';
import './style.css'
import FilterProjectsModal from '../../../components/Projects/Modal/FilterProjectsModal';
import MultiLevelDropdown from '../../../components/Projects/multi-level-dropdown';
import { useHistory, Link } from 'react-router-dom';
import FiltersListing from './filtersListing';
import { checkIsSomeItemAvailableInList, convertToTitleCase, numDifferentiation } from '../../../helpers/helpers';
import { Oval } from 'react-loader-spinner';
import Consumer from '../../../helpers/context';
import TooltipText from '../../../components/Tooltip';

import { ReactComponent as BuildingIcon } from '../../../assets/icons/golden_building.svg';
import { ReactComponent as PossessionIcon } from '../../../assets/icons/golden_calendar.svg';
import { ReactComponent as RupeesIcon } from '../../../assets/icons/rupees_icon.svg';
import { ReactComponent as ConfigIcon } from '../../../assets/icons/Category.svg';
import { ReactComponent as OfferImg } from '../../../assets/offers.svg';
import { ReactComponent as OfferRupeeIcon } from '../../../assets/plus_icon/offer_rupee.svg';
import Banner from '../../../components/Banner';
import SitevisitScheduleModal from '../../Plus LeadManager/Modal/siteviseScheduleModal';
import SitevisitReScheduleModal from '../../Plus LeadManager/Modal/sitevisitReScheduleModal';
import RequestToken from '../../Plus LeadManager/Modal/RequestToken';
import RequestBooking from '../../Plus LeadManager/Modal/RequestBooking';
import { object } from 'yup';
import ScheduleSiteVisitModal from '../../Plus LeadManager/Modal/ScheduleSiteVisitModal';
import Offers from './Offers';

const getProjectAddress = (project) => {
    const unitConfig = project.configurations
        .filter(item => item.unit_configuration)
        .map(item => item.unit_configuration)
    if (project.configurations?.length) {
        return `${unitConfig?.length ? unitConfig.join(', ') : ''} ${project.configurations[0].unit_type || ''} ${(project.city && project.state) ? `in ${project.city || ''}, ${project.state || ''}` : ''}`
    }
    // else {
    //     return `${project.configurations[0].unit_configuration ? project.configurations[0].unit_configuration : ''} ${project.configurations[0].unit_type || ''} ${(project.city && project.state) ? `in ${project.city || ''}, ${project.state || ''}` : ''}`
    // }
}

const numberFormat = (num) => {
    if (num >= 10000000) {
        return (num / 10000000).toFixed(2).replace(/\.0$/, '') + 'Cr'
    }
    if (num >= 100000) {
        return (num / 100000).toFixed(2).replace(/\.0$/, '') + 'L';
    }
    if (num >= 1000) {
        return (num / 1000).toFixed(2).replace(/\.0$/, '') + 'K';
    }
    return num
}

export default function Projects() {

    const [projects, setProjects] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [viewMore, setviewMore] = useState(false)
    const [selectedProject, setSelectedProject] = useState('');
    const [searchText, setSearchText] = useState('');
    const [filters, setFilters] = useState({});
    const [allProjects, setAllProjects] = useState([]);
    const [projectList, setProjectList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showSiteVisitModal, setShowSitevisitModal] = useState(false);
    const [countPerPage, setCountPerPage] = useState({
        value: 10,
        label: "10/Page"
    });

    const getAllProjects = async () => {
        setLoading(true);
        await getProjects({ ...filters }, searchText).then((res) => {
            setLoading(false);
            if (res.status === 200) {
                console.log(res.data.data, 'data')
                let projects = [...res.data.data];
                setProjectList(res.data.data)
                const spliced = projects.splice(0, 12);
                setProjects(spliced);
                // setProjects(projects);
                setAllProjects(projects)
            }
        }).catch((err) => {
            console.log("Something went wrong", err);
        })
    }


    useEffect(() => {
        getAllProjects();
    }, [currentPage, countPerPage, searchText, filters])

    const handelClearSearch = useCallback(() => {
        setSearchText('')
    }, []);


    const handleLoadMore = () => {
        let newList = [...allProjects];
        const spliced = newList.splice(0, 12);
        setProjects([...projects, ...spliced]);
        setAllProjects(newList);
    }

    return (
        <>
            <div className="all-pr d-flex flex-column flex-fill w-100 h-100 overflow-hidden">
                <div className="!px-5 !pt-4 !mb-10 ">
                    <div className="row d-flex flex-fill flex-wrap">
                        <div className="col-xl-4 d-flex flex-fill flex-row justify-content-between ">
                            <h1 className="text-2xl mb-0 black font-semibold inter">Projects </h1>
                        </div>
                        <div className="col-xl-8 justify-content-md-end d-flex align-items-center align-items-end gap-12 mt-xl-0">
                            <div className={`form-group position-relative flex items-center border rounded-lg !py-1 !px-4 mb-0 ${searchText ? 'border-primary' : ''} `}>
                                <div className="serch-icon">
                                    <img src={SearchIcon} className="" /></div>
                                <input type="text" placeholder="Search" onChange={(e) => setSearchText(e.target.value)} className="searchinput text-xs !ml-2 focus:outline-none active:border-0 " value={searchText} />
                                {searchText &&
                                    <div className="close-icon" onClick={handelClearSearch} style={{ top: '12px' }}>
                                        <SearchClosIoicn />
                                    </div>}
                            </div>
                            <button
                                className="gradient-blue flex !border !border-grayLight rounded-[8px] !px-3 !py-1.5 text-sm font-medium leading-5 text-white items-center" onClick={() => {
                                    setShowSitevisitModal(true);
                                }
                                }>
                                {/* <ResetIcon className="mr-2" /> */}
                                + Add Lead
                            </button>
                        </div>
                    </div>
                </div>

                <div className={`${style.all_project_table} all-project-table d-flex flex-fill flex-col overflow-auto  w-100`}>
                    <div className={`slider-project !w-full`} id='home'>
                        <Banner />
                    </div>
                    <div className='!px-5 '>
                        <div className='!my-8 text-xl font-semibold'>Explore Projects</div>
                        <div className={`${style.cardwidth} h-100 mx-auto`} >
                            <>
                                < div className={`${style.cardcenterview}`}>
                                    <div className={`flex flex-wrap !gap-8`} id='gridLayout'
                                    >
                                        {projects?.map((project, index) => {
                                            const { uuid, name } = project
                                            return (
                                                // <Link to={`/projects/details/${uuid}`} className='' >
                                                <div className={`${style.girdProjectCard} shadow-boxshadow !w-[343px] !p-0 !rounded-xl hover:!bg-white`}
                                                    key={uuid}
                                                >
                                                    <figure className='position-relative mb-16 !rounded-xl overflow-hidden'>
                                                        <div className='bg-gradient-to-r from-[#2064FA] to-[#3B37F5] w-max absolute text-white text-[10px] font-semibold top-2.5 left-2.5 !py-1 !px-2 rounded-lg'>Exclusive Launch</div>

                                                        <div className={`${style.projectcardMenu} view-more dropdown projectcardMenu`}>
                                                            <TooltipText title='View Option' placement="top">
                                                                <button className="!bg-[#111111]/50 border-0 w-6 h-6 inline-flex items-center justify-center hover:!bg-[#111111]  cursor-pointer" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                    <ThreedotsIcon />
                                                                </button>
                                                            </TooltipText>
                                                            <div className="dropdown-menu dropdown-menu-right w-auto" aria-labelledby="dropdownMenuButton">

                                                                <a className="dropdown-item text-capitalize fz12" onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    setShowSitevisitModal(true);
                                                                    setSelectedProject(project.uuid)
                                                                }}>
                                                                    Add New Lead
                                                                </a>
                                                                <a className="dropdown-item text-capitalize fz12"
                                                                    onClick={() => {
                                                                        window.open('/leads');
                                                                    }}
                                                                >
                                                                    View Submitted Leads
                                                                </a>
                                                            </div>
                                                        </div>
                                                        {project?.media?.length && <img src={project?.media[0]?.url} alt="" className='w-100' />}
                                                        {!project?.media?.length &&
                                                            <div className={`${style.cardthumbnail} d-flex align-items-center justify-content-center`}>
                                                                <HomeWhiteIcon />
                                                            </div>
                                                        }

                                                    </figure>
                                                    <div className='!py-3'>
                                                        <div className='flex justify-between px-3'>

                                                            <div className='flex flex-col'>
                                                                {name?.length > 30 ? <TooltipText title={name}>
                                                                    <h1 className='text-textblack inter text-xl font-bold mb4 lh-22 text-capitalize w-[300px] truncate'>
                                                                        {name}
                                                                    </h1>
                                                                </TooltipText> :
                                                                    <h1 className='text-textblack inter text-xl font-bold mb4 lh-22 text-capitalize'>
                                                                        {name}
                                                                    </h1>
                                                                }
                                                                {project.site_address && <p className='m-0 text-black700 text-xs'>
                                                                    {project.site_address || ''}
                                                                </p>}
                                                            </div>
                                                            <div className='h-12 w-12 rounded-lg'>
                                                                <img src={project?.logo || ''} alt="" className='rounded-lg' />
                                                            </div>
                                                        </div>

                                                        <div className='flex flex-col px-3 space-y-3 pt-3'>
                                                            <div className='flex justify-between'>
                                                                <div className='flex items-center w-7/12 gap-2'>
                                                                    <span className='w-4 h-4 grow-0 shrink-0 basis-4'>
                                                                        <RupeesIcon />
                                                                    </span>
                                                                    <span className='text-black800 text-xs font-medium'> {project?.starting_price ? `Starts at ₹${numberFormat(+project?.starting_price)}` : '-'}</span>
                                                                </div>
                                                                <div className='flex items-center w-5/12  gap-2'>
                                                                    <span className='w-4 h-4 grow-0 shrink-0 basis-4'>
                                                                        <BuildingIcon />
                                                                    </span>
                                                                    <span className='text-black800 text-xs font-medium'>{project?.configuration.join(', ')} </span>
                                                                </div>
                                                            </div>
                                                            <div className='flex justify-between'>
                                                                {project?.possession_date && <div className='flex items-center w-7/12 gap-2'>
                                                                    <span className='w-4 h-4 grow-0 shrink-0 basis-4'>
                                                                        <PossessionIcon />
                                                                    </span>
                                                                    <span className='text-black800 text-xs font-medium'> Possession: {moment(project?.possession_date).format('MMM YYYY')}  </span>
                                                                </div>}
                                                                {project?.unit_configuration.length > 0 && <div className='flex items-center w-5/12	gap-2'>
                                                                    <span className='w-4 h-4 grow-0 shrink-0 basis-4'>
                                                                        <ConfigIcon />
                                                                    </span>
                                                                    <TooltipText title={project.unit_configuration.join(', ')}>
                                                                        <div className='truncate text-black800 text-xs font-medium w-full'> {project.unit_configuration.join(', ')} </div>
                                                                    </TooltipText>
                                                                </div>}
                                                            </div>
                                                        </div>
                                                        {project.offers.length > 0 &&
                                                            <div className='offer-slider !w-full' >
                                                                <div className='px-3 my-3 uppercase text-[10px] text-[#667085] font-medium flex items-center gap-2'>Offers <span className='w-full h-px border-b border-grayLight border-dashed inline-block'></span></div>
                                                                <div className='pl-3 offerslider'>
                                                                    <Offers offers={project?.offers} setShowSitevisitModal={setShowSitevisitModal} setSelectedProject={setSelectedProject} project={project} />
                                                                </div>

                                                            </div>
                                                        }
                                                    </div>

                                                    <Link to={`/projects/details/${uuid}`} className={`${style.cardviewProjectbtn}`}></Link>

                                                </div>
                                                // </Link>
                                            )
                                        })
                                        }
                                    </div >
                                    {
                                        allProjects?.length > 6 ? <div className={`${style.loadMorediv} !pb-0 !mb-0`}>
                                            <button className="text-[#344054] text-base font-semibold !border border-grayLight rounded-lg py-2.5 px-[70px] hover:text-white hover:bg-gradient-to-r from-[#2064FA] to-[#3B37F5]" onClick={handleLoadMore}>View more</button>
                                        </div> : ''
                                    }
                                </div>
                                {/* {allProjects?.length === 0 &&
                                    <div className='d-flex justify-content-center flex-column text-center h-100'>
                                        <div>
                                            <figure><Searchicon /></figure>
                                            <h2 className="po black fz16 fw-po-medium mb-8 text-capitalize">No Projects Added</h2>
                                            <p className='text-center black-dark-600 fz14 mb-4 text-capitalize'>Please add projects to see them here</p>
                                            <button className={`${style.addnewprojectbtn}`}>+ New Project</button>

                                        </div>
                                    </div>
                                } */}
                            </>

                            {loading &&
                                <div className='d-flex justify-content-center align-items-center h-100 w-100'>
                                    <Oval
                                        height={30}
                                        width={30}
                                        color="#0062ff"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                        visible={true}
                                        ariaLabel='oval-loading'
                                        secondaryColor="#0062ff"
                                        strokeWidth={4}
                                        strokeWidthSecondary={4}
                                    />

                                </div>}
                            {searchText && projectList?.length === 0 &&
                                <div className='d-flex justify-content-center flex-column text-center h-100'>
                                    <div className='flex justify-center flex-column items-center'>
                                        <figure><Searchicon /></figure>
                                        <h2 className="po black fz16 fw-po-medium mb-8 text-capitalize">Didn’t find any matches </h2>
                                        <p className='text-center black-dark-600 fz14 mb-4 text-capitalize'>We're sorry, but we couldn't find any results for your search.
                                            <sapn className='d-md-block d-none'>Please try again with different keywords.</sapn></p>
                                    </div>

                                </div>}
                            {!searchText && projectList?.length === 0 &&
                                <div className='flex justify-center flex-column text-center h-100'>
                                    <div className='flex justify-center flex-column items-center'>
                                        <figure><Searchicon /></figure>
                                        <h2 className="po black fz16 fw-po-medium mb-8 text-capitalize">No Projects Added</h2>
                                        <p className='text-center black-dark-600 fz14 mb-4 text-capitalize'>Please add projects to see them here</p>

                                    </div>
                                </div>
                            }
                        </div >
                    </div>
                </div >
                {showSiteVisitModal && <ScheduleSiteVisitModal
                    show={showSiteVisitModal}
                    closeModal={() => {
                        setShowSitevisitModal(false)
                        setSelectedProject('')
                    }}
                    uuid={selectedProject}
                    redirectFrom='project'
                />}
            </div >
            {/* <FilterProjectsModal show={showfilter} closeModal={() => setShowfilter(false)} handleApplyFilters={handleApplyFilters} style={style} /> */}
            {/* <SitevisitScheduleModal show={true} /> */}
            {/* <SitevisitReScheduleModal show={true} /> */}
            {/* <RequestToken show={true} /> */}
            {/* <RequestBooking  show={true} /> */}
        </>
    )
}

